import { defineComponent as _defineComponent } from 'vue'
import VueDraggable from "vuedraggable";
import { computed, getCurrentInstance, PropType, nextTick } from "vue";
import QDraggableListItem from "./QDraggableListItem.vue";
import { useDraggingGroup } from "./useDraggingGroup";
import { useThrottleModelValue } from "../../composables/useThrottleSyncProp";


export default /*#__PURE__*/_defineComponent({
  __name: 'QDraggableListRoot',
  props: {
  value: {
    type: Array as PropType<any[]>,
    required: true,
  },
  childrenKey: {
    type: String,
    default: "children",
  },
  titleKey: {
    type: String,
    default: "name",
  },
  color: {
    type: String,
    default: "primary",
  },
  depth: {
    default: 0
  },
  // Allow moving items between lists with different depths
  multiDepth: {
	type: Boolean,
	default: false
  }
},
  emits: ["input"],
  setup(__props, { emit }) {

const props = __props





const vm = getCurrentInstance()!

const groupId = computed(() => 'group-' + (vm as any).proxy._uid);

const { draggroup } = useDraggingGroup()

const items = useThrottleModelValue(props, emit)

const renderItems = computed({
  get() {
    return items.value
  },
  async set(v) {
    items.value = v
  }
})

const itemUpdated = async (newItem: any, oldItem: any) => {
  // Item updated before list is updated. We need to wait until list is updated with new order, then we can update the item.
  await nextTick()
  items.value = items.value.map((item: any) => {
    return item === oldItem ? newItem : item
  })
}

return { __sfc: true,props, emit, vm, groupId, draggroup, items, renderItems, itemUpdated, VueDraggable, QDraggableListItem }
}

})